import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance/axiosInstance";
import { MilestoneNote } from "./MilestoneNote";

export const fetchMilestoneNotes = createAsyncThunk(
  "milestoneNotes/fetchMilestoneNotes",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MilestoneNote[]>(
        `/milestonenotes?milestoneId=${milestoneId}`
      );
      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

export const addMilestoneNote = createAsyncThunk(
  "milestoneNotes/addMilestoneNote",
  async (
    { milestoneId, text }: { milestoneId: number; text: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post<MilestoneNote>(
        "/milestonenotes",
        { milestoneId, text }
      );
      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

export const deleteMilestoneNote = createAsyncThunk(
  "milestoneNotes/deleteMilestoneNote",
  async (noteId: number, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/milestonenotes/${noteId}`);
      return noteId;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);
